import { Component, Input, OnInit } from '@angular/core';
import { AttachmentDto, FranchiseDetail, GetFranchseSuspensionModel } from 'src/app/admin/models/franchise-detail';
import { AttachmentTypes } from 'src/app/franchise-app-global';
import { AttachmentService } from 'src/app/services/AttachmentService';
@Component({
  selector: 'app-violated-section',
  templateUrl: './violated-section.component.html',
  styleUrls: ['./violated-section.component.scss']
})
export class ViolatedSectionComponent implements OnInit {
  @Input() franchise: FranchiseDetail;
  franchiseSuspension?: GetFranchseSuspensionModel;
  attachment?: AttachmentDto;
  constructor(private attachmentService: AttachmentService) { }

  ngOnInit(): void {
    this.franchiseSuspension = this.franchise?.franchiseSuspension;
    this.attachment = this.franchise?.attachments.find(attachment => attachment.attachmentTypeId == AttachmentTypes.ViolateReason);
  }

  downloadAttachment(): void {
    let fileName = this.attachment?.fileName;
    let publicId = this.attachment?.publicId;
    this.attachmentService.DownloadAdminFile(publicId ?? "", fileName ?? "");
  }
}
